import { IoChevronDown } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { useState } from "react";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";

export const SearchBar = (props) => {
  const {
    label,
    labelClass = "",
    containerClass = "",
    inputClass = "",
    iconClass = "",
    placeholder = "Search...",
    options = [],
    value,
    multiple = false,
    onChange,
    optionMenuClass = "",
    className = "",
    multiselectClass = "",
    required = false,
    ...rest
  } = props;

  const [query, setQuery] = useState("");

  const filteredOptions =
    query === ""
      ? options
      : options.filter((data) => {
          return data?.name?.toLowerCase().includes(query.toLowerCase());
        });

  const hasOptions = options.length > 0;
  const allValues = hasOptions ? options.map((o) => o.value) : [];
  const isAllSelected =
    multiple && hasOptions && value?.length === allValues.length;

  function toggleSelectAll() {
    if (!multiple) return;
    if (!hasOptions) return;
    if (isAllSelected) onChange([]);
    else onChange(allValues);
  }

  return (
    <div className={`searchbar-root ${className}`}>
      {label && <label className={labelClass}>{label}</label>}

      <Combobox
        multiple={multiple}
        immediate
        value={value ?? ""}
        onChange={onChange}
        onClose={() => setQuery("")}
        as="div"
        className="combobox-wrapper"
      >
        <div
          className={`combobox-container ${containerClass} ${
            !multiple ? "no-scroll" : ""
          }`}
        >
          <div className="combobox-input-row">
            <ComboboxInput
              required={required && !(multiple && value?.length)}
              className={`combobox-input ${inputClass}`}
              autoComplete="off"
              displayValue={(data) =>
                options.find((opt) => opt.value === data)?.name
              }
              placeholder={placeholder}
              onChange={(event) => setQuery(event.target.value)}
              {...rest}
            />
            <ComboboxButton className="combobox-button">
              <IoChevronDown className={`combobox-icon ${iconClass}`} />
            </ComboboxButton>
          </div>

          {Array.isArray(value) && (
            <div className={`multi-selected-container ${multiselectClass}`}>
              {value?.map((data) => (
                <span key={data}>
                  {options.find((opt) => opt.value === data)?.name},&nbsp;
                </span>
              ))}
            </div>
          )}
        </div>

        <ComboboxOptions
          transition
          className={`options-container ${optionMenuClass}`}
        >
          {multiple && hasOptions && (
            <div onClick={toggleSelectAll} className="option select-all">
              <div className="option-text">
                Select All {isAllSelected ? "(✓)" : ""}
              </div>
            </div>
          )}

          {filteredOptions.length > 0 ? (
            filteredOptions.map((data) => (
              <ComboboxOption
                key={data.value}
                value={data.value}
                className="option"
              >
                <div className="option-text">{data.name}</div>
                {value == data.value && (
                  <FaRegCheckCircle className="option-check" />
                )}
              </ComboboxOption>
            ))
          ) : (
            <ComboboxOption value={undefined} className="option">
              <div className="option-text">Not available</div>
            </ComboboxOption>
          )}
        </ComboboxOptions>
      </Combobox>
    </div>
  );
};
